import styled from 'styled-components';

export const NoContentPlaceholderWrapper = styled.div`
  margin-top: 2rem;
  text-align: center;
  color: rgb(207, 207, 212);
`;
